<mat-form-field
  class="filter-form"
  appearance="outline"
  (click)="$event.stopPropagation(); $event.preventDefault()"
  (keyup)="$event.stopPropagation(); $event.preventDefault()">
  <mat-label>
    {{ 'Filter.Value' | translate: locale.language }}
  </mat-label>
  <mat-chip-grid #chipGrid [attr.data-test]="'filter-chip-grid'">
    @for (chip of selectedChips(); track $index) {
      <mat-chip-row
        [highlighted]="isVariable(chip)"
        [color]="isVariable(chip) ? 'primary' : ''"
        [removable]="true"
        (removed)="removeChip(chip)"
        (keydown.enter)="$event.stopPropagation(); $event.preventDefault(); this.autocompleteTrigger.closePanel()"
        (click)="$event.stopPropagation(); $event.preventDefault(); this.autocompleteTrigger.closePanel()"
        [attr.data-test]="'filter-chip-' + chip"
        [matTooltip]="getValue(chip)">
        <span class="selected-chip-value">{{ getValue(chip) }}</span>
        <button matChipRemove [attr.data-test]="'filter-chip-remove-' + chip" [attr.aria-label]="'Remove ' + chip">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
  </mat-chip-grid>
  <input
    #input
    [attr.data-test]="'filter-chip-input'"
    [matChipInputFor]="chipGrid"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    (matChipInputTokenEnd)="addChip($event)"
    [matAutocomplete]="auto"
    [formControl]="inputControl"
    [placeholder]="'Search...' | translate: locale.language"
    (blur)="onInputBlur()"
    (click)="$event.stopPropagation(); $event.preventDefault()" />
  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="selected($event)"
    [autoActiveFirstOption]="true"
    (closed)="onAutocompleteClosed()">
    <mat-option [value]="null" [attr.data-test]="'filter-option-none'">
      @if (loading()) {
        {{ 'Loading' | ellipsis | translate: locale.language }}
      } @else {
        {{ '--- None ---' | translate: locale.language }}
      }
    </mat-option>
    @for (option of filteredOptions(); track $index) {
      <mat-option [value]="option" [attr.data-test]="'filter-option-' + option">
        {{ option }}
      </mat-option>
    }
  </mat-autocomplete>
  @if (loading()) {
    <mat-spinner matIconSuffix [diameter]="20" class="search-spinner" />
  }
</mat-form-field>
